module.exports = __webpack_public_path__ + "img/icon-mail.137f6993.svg";